export default __webpack_public_path__ + "static/media/invites.55982803.png";